import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';

export default class MoveStaffToExternalBranch extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    staffpreferredName: PropTypes.string,
    headerNode: PropTypes.node,
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e);
    }
  }
  render() {
    return (
      <Modal
        basic
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Header icon="warning sign" content={this.props.headerNode || 'Confirm move staff to agency?'} />
        <Modal.Content>
          <Modal.Description>
            <p>This action will downgrade <strong>{this.props.staffpreferredName || 'this staff'}</strong> to agent access level.</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={this.handleOnClose} icon="cancel" content="Cancel" inverted />
          <Button basic positive onClick={this.handleOnComfirm} icon="checkmark" content="Confirm" inverted />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/MoveStaffToExternalBranch.jsx